import React from 'react';
import Router from 'next/router'
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import BookmarkButton from "@atoms/bookmark";
import ButtonTransparent from "@atoms/button.transparent";
import {isEmpty} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import Icon from "@atoms/icon";
import ArrowRightIcon from "@icons/arrow-right.svg";
import ShareIcon from "@icons/share.svg";
import Link from "next/link";

function TopFixedActions({property, bookmarkedProperties, className, isBadeSaba = false, handleBookmark, handleBackToListUrl, setShare}) {
    return (
        <Container className={'d-flex align-items-center justify-content-between px-24 ' + (className ? className : '')}>

            {
                (process.browser && history.length < 2) ?
                    <Link href="/properties" as={handleBackToListUrl()}>
                        <a className="d-flex">
                            <Icon width={16}><ArrowRightIcon/></Icon>
                        </a>
                    </Link>
                    :
                    <Back className="d-flex" onClick={() => Router.back()}>
                        <Icon><ArrowRightIcon/></Icon>
                    </Back>
            }

            <Code>
                {
                    (!isEmpty(property)) ?
                        ' کد آگهی:' + property.id
                        :
                        <Skeleton width={100}/>
                }
            </Code>

            <div className="d-flex align-items-center">
                {
                    (!isEmpty(property)) ?
                        ((!property.archived) ?
                            <React.Fragment>
                                <ButtonTransparent className="d-flex" onClick={() => setShare(true)}>
                                    <Icon width={16} height={16}><ShareIcon/></Icon>
                                </ButtonTransparent>

                                {
                                    (!isBadeSaba) ?
                                        <BookmarkButton className={"d-flex mr-24 p-0 " + (inArray(property.id, bookmarkedProperties) ? 'active' : '')} width={16} height={16} onClick={() => handleBookmark(!inArray(property.id, bookmarkedProperties))}/>
                                        : ''
                                }
                            </React.Fragment>
                            : '')
                        :

                        <React.Fragment>
                            <Skeleton width={24} height={24} circle={true}/>
                            <Skeleton className="mr-8" width={24} height={24} circle={true}/>
                        </React.Fragment>
                }
            </div>

        </Container>
    )
}

export default React.memo(TopFixedActions);

// styles
const Code = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: ${props => props.theme.fontSizeBase};
    font-weight: normal;
    line-height: 1.8;
    color: ${props => props.theme.black};
`;

const Back = styled(ButtonTransparent)`
    .icons {
        width: 16px;
        max-width: 16px;
    }
`;

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 55px;
    background-color: ${props => props.theme.white};
    z-index: 5001;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 0px !important;
`;